// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
  palette: {
    mode: 'dark', // optional: gives dark UI look
    primary: {
      main: '#ffcb05',
    },
    background: {
      default: '#0c1e3c',
    },
  },
});

export default theme;
